<template>
  <div>
    <div class="mb-10 relative">
      <ValidationProvider rules="email|required|min:2" v-slot="{ invalid, errors }">
        <zt-input
          outlined
          name="email"
          :label="$t('message.loginComponent.languagesVuetify.mail')"
          :style="[loginCustomParamsFields.styles.form.inputs.bgColor]"
          :color="colorOutlineEmail(invalid)"
          v-model="value.userEmail"
          data-vs-input="auth-forgotpass-fields-input-email"
        />
        <span class="text-zt-danger absolute left-0" v-show="errors[0]">{{
          $t('message.loginComponent.validations.emailRules.validMail')
        }}</span>
      </ValidationProvider>
    </div>
    <div class="mb-4 pb-2 relative">
      <ValidationProvider :rules="{ required: true, regex: /^[a-zA-Z0-9_]{1,32}$/ }" v-slot="{ invalid, errors }">
        <zt-input
          outlined
          name="user"
          :label="loginCustomParamsFields.textLabels.user"
          :style="[loginCustomParamsFields.styles.form.inputs.bgColor]"
          :color="colorOutlineUser(invalid)"
          v-model="value.userName"
          @keypress="activeButton"
          data-vs-input="auth-forgotpass-fields-input-user"
        />
        <span class="text-zt-danger absolute left-0" v-show="errors[0]">
          {{ errors[0] }}
        </span>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { localize } from 'vee-validate';

export default {
  name: 'ztAuthForgotPassFields',
  props: {
    value: {
      type: Object,
      default: () => ({
        userName: '',
        userEmail: ''
      })
    },
    loginCustomParamsFields: {
      type: Object,
      default: () => {}
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data() {
    return {}
  },
  created() {
    localize('es')
    localize({
      es: {
        messages: {
          required: this.$t('message.loginComponent.validations.userRules.requireUser'),
          min: this.$t('message.loginComponent.validations.userRules.minCharacters', {min: '{length}'}),
          regex: this.$t('message.loginComponent.validations.userRules.charactersValidation')
        }
      }
    });
  },
  computed: {
    colorOutlineUser() {
      return invalid =>
        invalid
          ? 'danger'
          : this.loginCustomParamsFields.styles.form.inputs.outlineColor
    },
    colorOutlineEmail() {
      return invalid =>
        invalid
          ? 'danger'
          : this.loginCustomParamsFields.styles.form.inputs.outlineColor
    }
  },
  methods: {
    activeButton(event) {
      if (event.keyCode === 13) {
        event.preventDefault()
        this.$emit('activeButton')
      }
    }
  }
}
</script>

<style scoped></style>
